import React, { ReactNode } from 'react';
import { Body } from '@sato/components';

/** Optional description text above a widget's button */
export const WidgetButtonLayout = ({
  description,
  children,
}: {
  description?: string;
  children: ReactNode;
}) => (
  <div className="mb-3 flex flex-col gap-3">
    {description && <Body>{description}</Body>}
    {children}
  </div>
);
